import Help from 'tools/Modal/Help'

// get rid of the default top margin so it can easily sit within gv4
export function Label2({ className = 'mb3', ...args }) {
  return <Label className={className} {...args} />
}

export function Label({
  maxLength,
  value,
  dirty,
  children,
  margins = 'mb3 mt4',
  alignment = 'flex items-center flex-wrap flex-wrap-none-s ga2',
  className = '',
  accent = 'accent',
  help
}) {
  return (
    <label className={`${accent} ${className} ${alignment} ${margins}`}>
      {children}
      {help && (
        <Help title={children} className="">
          {help}
        </Help>
      )}
      {maxLength && <Showlength value={value} max={maxLength} dirty={dirty} />}
    </label>
  )
}

function Showlength({ value, max, dirty }) {
  if (!max || !dirty) {
    return null
  }
  return (
    <div className={`fw1 f2 i ${value?.length === max ? '' : 'minimize'}`}>
      ({value.length} of {max})
    </div>
  )
}

// reconcile w/InputLabel too
export function WarnLabel({
  label,
  ready = true,
  children = undefined,
  className = ''
}) {
  return (
    <div className={className}>
      <Label className={`mb3 ${!ready ? 'warn' : ''}`}>
        {!ready ? '* ' : ''}
        {label}
      </Label>
      {!ready ? <div className="i warn">{children}</div> : null}
    </div>
  )
}
